module.exports = __webpack_public_path__ + "img/new_07.0aab3ed4.jpg";